import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./footer.css";



const Footer = ({info}) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const scrollWithOffset = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    const navbarHeight = document.querySelector('.navbar-container')?.offsetHeight || 0;
    const top = el.getBoundingClientRect().top + window.scrollY - navbarHeight;
    window.scrollTo({ top, behavior: 'smooth' });
  };

  const scrollToContact = () => {
    scrollWithOffset('contact-form');
  };

  const scrollToHome = () => {
    if (pathname === '/') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      navigate('/');
    }
  };

  const scrollToAbout = () => {
    if (pathname === '/') {
      scrollWithOffset('about');
    } else {
      navigate('/', { state: { scrollTo: 'about' } });
    }
  };

  const scrollToCustomers = () => {
    if (pathname === '/') {
      scrollWithOffset('customers');
    } else {
      navigate('/', { state: { scrollTo: 'customers' } });
    }
  };

  const goToExpect = () => {
    if (pathname === '/') {
      scrollWithOffset('what-you-can-expect');
    } else {
      navigate('/', { state: { scrollTo: 'what-you-can-expect' } });
    }
  };

  const goToWhyChoose = () => {
    if (pathname === '/') {
      scrollWithOffset('why-choose');
    } else {
      navigate('/', { state: { scrollTo: 'why-choose' } });
    }
  };

  const goToServices = () => {
    if (pathname === '/services') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      navigate('/services');
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Contact Section */}
        <div className="footer-section">
          <h3>{info.title}</h3>
          <div className="footer-line"/>
          <ul className="footer-contact">
            <li><strong>{info.email}:</strong> laura.rodriguez@protargetgroupllc.com</li>
            <li><strong>{info.phone}:</strong> (310) 940-6661</li>
            <li><strong>{info.address}:</strong> Bishop Ranch 3, 2603 Camino Ramon Suite 200, San Ramon, CA 94583</li>
          </ul>
        </div>

        {/* Quick Links Section */}
        <div className="footer-section">
          <h3>{info.links}</h3>
          <div className="footer-line"/>
          <ul className="footer-links">
            <li><button className="no-hover" onClick={scrollToHome}>{info.home}</button></li>
            <li><button className="no-hover" onClick={scrollToAbout}>{info.about}</button></li>
            <li><button className="no-hover" onClick={goToServices}>{info.services}</button></li>
            <li><button className="no-hover" onClick={goToExpect}>{info.expect}</button></li>
            <li><button className="no-hover" onClick={scrollToCustomers}>{info.customers}</button></li>
            <li><button className="no-hover" onClick={scrollToContact}>{info.contact}</button></li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p className="copyright">&copy; {new Date().getFullYear()} ProTarget Group LLC. {info.rights}.</p>
      </div>
    </footer>
  );
};

export default Footer;

